import React, { useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import "./Header.css";

const Header = ({ onSignIn, onJoinNow, onAbout, onHome, onServices, currentPage }) => {
  const { t, i18n } = useTranslation();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [language, setLanguage] = useState(localStorage.getItem("selectedLanguage") || "en");
  const [languageMenuStatus, setLanguageMenuStatus] = useState(false);
  const wrapperRef = useRef(null);

  const toggleMobileMenu = () => setIsMobileMenuOpen(!isMobileMenuOpen);

  const handleNavClick = (callback) => {
    setIsMobileMenuOpen(false);
    if (callback) callback();
  };




  const getFlagEmoji = (countryCode) =>
    String.fromCodePoint(...[...countryCode.toUpperCase()].map((c) => 127397 + c.charCodeAt()));

  const handleChangeLanguage = (e, lang) => {
    e.preventDefault();
    e.stopPropagation();
    i18n.changeLanguage(lang);
    localStorage.setItem("selectedLanguage", lang);
    setLanguage(lang);
    setLanguageMenuStatus(false);
  };

  return (
    <header className="wc-header">
      {/* Logo */}
      
      <div className="wc-header-logo">{t("WomenConnect")}</div>

      {/* Desktop Navigation */}
      <nav className="wc-header-nav desktop-nav">
        {currentPage !== "home" && (
          <div onClick={() => handleNavClick(onHome)} className={currentPage === "home" ? "active" : ""}>
            {t("Home")}
          </div>
        )}

        <div onClick={() => handleNavClick(onServices)} className={currentPage === "services" ? "active" : ""}>
          {t("Services")}
        </div>

        <div onClick={() => handleNavClick(onAbout)} className={currentPage === "about" ? "active" : ""}>
          {t("About")}
        </div>
      </nav>

      {/* Desktop Buttons */}
      <div className="wc-header-actions desktop-actions">
        <button className="wc-sign-in" onClick={onSignIn}>
          {t("Sign In")}
        </button>
        <button className="wc-join-now" onClick={onJoinNow}>
          {t("Join Now")}
        </button>

        {/* 🌐 Language Selector */}
        <div
  className="selected-lang-option ml-2"
  onClick={() => setLanguageMenuStatus(!languageMenuStatus)}
>
  {language === "ta" ? (
    <p>{getFlagEmoji("IN")}</p>
  ) : language === "gu" ? (
    <p>{getFlagEmoji("IN")}</p>
  ) : language === "hi" ? (
    <p>{getFlagEmoji("IN")}</p>
  ) : language === "fr" ? (
    <p>{getFlagEmoji("FR")}</p>
  ) : language === "sp" ? (
    <p>{getFlagEmoji("ES")}</p>
  ) : language === "te" ? (
    <p>{getFlagEmoji("IN")}</p>
  ) : (
    <p><span>&#127760;</span></p>
  )}

  {languageMenuStatus && (
    <div className="lang-card z-1000 lang-card-v2" ref={wrapperRef}>
      <div className="lang-card-overflow lang-card-v2-con">
        <div
          className={language === "en" ? "bg-color" : ""}
          onClick={(e) => handleChangeLanguage(e, "en")}
        >
          <p><span>&#127760; </span> English</p>
        </div>
        <div
          className={language === "ta" ? "bg-color" : ""}
          onClick={(e) => handleChangeLanguage(e, "ta")}
        >
          <p>{getFlagEmoji("IN")} தமிழ்</p>
        </div>
        <div
          className={language === "hi" ? "bg-color" : ""}
          onClick={(e) => handleChangeLanguage(e, "hi")}
        >
          <p>{getFlagEmoji("IN")} हिंदी</p>
        </div>
        <div
          className={language === "te" ? "bg-color" : ""}
          onClick={(e) => handleChangeLanguage(e, "te")}
        >
          <p>{getFlagEmoji("IN")} తెలుగు</p>
        </div>
        <div
          className={language === "fr" ? "bg-color" : ""}
          onClick={(e) => handleChangeLanguage(e, "fr")}
        >
          <p>{getFlagEmoji("FR")} Français</p>
        </div>
        <div
          className={language === "sp" ? "bg-color" : ""}
          onClick={(e) => handleChangeLanguage(e, "sp")}
        >
          <p>{getFlagEmoji("ES")} Española</p>
        </div>
      </div>
    </div>
  )}
</div>

      </div>

      {/* Mobile Menu Button */}
      <button className="mobile-menu-toggle" onClick={toggleMobileMenu} aria-label="Toggle menu">
        <span className={`hamburger ${isMobileMenuOpen ? "open" : ""}`}>
          <span></span>
          <span></span>
          <span></span>
        </span>
      </button>

      {/* Mobile Overlay Menu */}
      <div className={`mobile-menu-overlay ${isMobileMenuOpen ? "open" : ""}`}>
        <nav className="mobile-nav">
          {currentPage !== "home" && (
            <div onClick={() => handleNavClick(onHome)} className={currentPage === "home" ? "active" : ""}>
              {t("Home")}
            </div>
          )}
          <div onClick={() => handleNavClick(onServices)} className={currentPage === "services" ? "active" : ""}>
            {t("Services")}
          </div>
          <div onClick={() => handleNavClick(onAbout)} className={currentPage === "about" ? "active" : ""}>
            {t("About")}
          </div>

          <div className="mobile-actions">
            <button className="wc-sign-in" onClick={() => handleNavClick(onSignIn)}>
              {t("Sign In")}
            </button>
            <button className="wc-join-now" onClick={() => handleNavClick(onJoinNow)}>
              {t("Join Now")}
            </button>
          </div>
        </nav>
      </div>
    </header>
  );
};

export default Header;
